import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { CheckboxDialogComponent } from "./checkbox-dialog.component";
import { CheckboxDialogService } from "./checkbox-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
    ],

    declarations: [CheckboxDialogComponent],
    exports: [CheckboxDialogComponent],
    providers: [CheckboxDialogService],
})
export class CheckboxDialogModule {}